import { PencilSimpleLine } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { partFinderFamilyPath } from 'companySettings/routes';
import { IPartFinderFamily } from 'companySettings/types';
import { Button } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { Variant } from 'theme/enums';

import { UpsertPartFinderFamilyButton } from '../UpsertPartFinderFamily';
import { opensInWizard } from '../utils';

// One family at a time: a draft still being set up opens in the wizard, any other in its editor.
export const EditPartFinderFamilyButton = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { selectedRows } = useAgGridClientTableContext();

  const family = 1 === selectedRows?.length ? (selectedRows[0] as IPartFinderFamily) : undefined;

  const button = (
    <Button
      text={t('buttonLabelEdit')}
      variant={Variant.OUTLINED}
      startDecorator={<PencilSimpleLine />}
      disabled={!family}
      onClick={
        family && !opensInWizard(family)
          ? () => navigate(partFinderFamilyPath(family.id))
          : undefined
      }
    />
  );

  return family && opensInWizard(family) ? (
    <UpsertPartFinderFamilyButton family={family} buttonElement={button} />
  ) : (
    button
  );
};
